import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Card } from '../../base/card/Card.js';
import { BillDue } from '../billDue/BillDue.js';
import { Button } from '../../base/button/Button.js';
import { SuccessIcon } from '../../icons/SuccessIcon.js';
import { ArrowUpTrendIcon } from '../../icons/ArrowUpTrendIcon.js';
import { BillType, BillStatus } from './Bill.types.js';
import styles from './Bill.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var getProductName = function (productCategory, productDetails, productNumber) {
    if (productCategory === 'HDC1DOT0') {
        return 'Drivers Club 1.0 membership';
    }
    else if (productCategory === 'HDC1DOT5') {
        return 'Drivers Club membership';
    }
    else if (productDetails && productDetails.length === 0) {
        return productNumber ? "Policy #".concat(productNumber) : "Policy";
    }
    else {
        return "".concat(productDetails[0]).concat(productDetails && productDetails.length > 1 ? " +".concat(productDetails.length - 1) : '');
    }
};
var getPaymentPlan = function (productCategory, isRecursive) {
    if (productCategory === 'HDC1DOT5') {
        return 'Annual Payment Plan';
    }
    if (productCategory === 'HDC1DOT0') {
        return isRecursive ? 'Monthly Payment Plan' : 'Annual premium';
    }
    return null;
};
var Bill = function (_a) {
    var bill = _a.bill, className = _a.className, style = _a.style, returnButtonLabel = _a.returnButtonLabel, returnUrl = _a.returnUrl, onPayClick = _a.onPayClick, onViewDetailsClick = _a.onViewDetailsClick, onAction = _a.onAction, _b = _a.isDirectContactRequired, isDirectContactRequired = _b === void 0 ? false : _b;
    var type = bill.type, category = bill.category, productNumber = bill.productNumber, nextPaymentDate = bill.nextPaymentDate, productDetails = bill.productDetails, isSubmitted = bill.isSubmitted, paymentUrl = bill.paymentUrl, alignedBill = bill.alignedBill, total = bill.total;
    var isAutoPay = type === BillType.AutoPay;
    var name = getProductName(category, productDetails, productNumber);
    var updatedPaymentUrl = paymentUrl;
    if (!onPayClick && !isAutoPay) {
        if (returnUrl) {
            var params = new URLSearchParams(__assign({ returnUrl: returnUrl }, (returnButtonLabel ? { returnButtonLabel: returnButtonLabel } : undefined)));
            updatedPaymentUrl = paymentUrl + '?' + params.toString();
        }
    }
    var viewDetailsProps = onViewDetailsClick
        ? {
            onClick: function () {
                onViewDetailsClick(bill);
                onAction === null || onAction === void 0 ? void 0 : onAction('details', bill);
            },
        }
        : { as: 'a', href: updatedPaymentUrl, onClick: function () { return onAction === null || onAction === void 0 ? void 0 : onAction('details', bill); } };
    var payNowProps = onPayClick
        ? {
            onClick: function () {
                onPayClick(bill);
                onAction === null || onAction === void 0 ? void 0 : onAction('pay', bill);
            },
        }
        : { as: 'a', href: updatedPaymentUrl, onClick: function () { return onAction === null || onAction === void 0 ? void 0 : onAction('pay', bill); } };
    var productDescription = alignedBill
        ? getProductName(alignedBill.category, [], alignedBill.productNumber)
        : getPaymentPlan(category, isAutoPay);
    return (jsxs(Card, __assign({ as: "article", "aria-label": "bill", className: clsx(styles.card, className), style: style }, { children: [isDirectContactRequired && jsx("p", __assign({ className: styles.enthusiastPolicyTitle }, { children: "[Enthusiast+] policy" })), jsx(Card.Title, __assign({ className: clsx(isDirectContactRequired && styles.title) }, { children: total.formattedAmount })), nextPaymentDate && (jsx(BillDue, { date: nextPaymentDate, variant: isAutoPay ? 'recursive' : 'single', hasError: bill.informAboutStatus && bill.status !== BillStatus.Ok })), jsx(Card.Separator, {}), jsx("p", __assign({ className: clsx(isDirectContactRequired && styles.productName) }, { children: name })), productDescription && (jsxs(Fragment, { children: [jsx(Card.Separator, {}), jsx("p", __assign({ className: clsx(isDirectContactRequired && styles.annualPremium) }, { children: productDescription }))] })), bill.revalOffer && (jsxs(Fragment, { children: [jsx(Card.Separator, {}), jsxs("p", __assign({ className: styles.revaluationLabel }, { children: [jsx(ArrowUpTrendIcon, { variant: "secondary" }), " New vehicle value(s) available"] }))] })), jsxs(Card.Footer, __assign({ as: "footer", className: clsx(isDirectContactRequired && styles.footer) }, { children: [isSubmitted && (jsxs("p", __assign({ className: styles.paymentSubmitted }, { children: [jsx(SuccessIcon, {}), " Payment submitted"] }))), !isSubmitted && isAutoPay && !isDirectContactRequired && (jsx(Button, __assign({ color: "secondary", size: "m" }, viewDetailsProps, { children: "View details" }))), !isDirectContactRequired && !isSubmitted && !isAutoPay && (jsx(Button, __assign({ size: "m" }, payNowProps, { children: bill.revalOffer ? 'Review and pay' : 'Pay now' }))), isDirectContactRequired && !isSubmitted && !isAutoPay && (jsxs("div", __assign({ className: styles.callToPayWrapper }, { children: [jsx(Button, __assign({ size: "m", as: "a", href: "tel:8888888888" }, { children: "Call to pay" })), jsxs("p", { children: ["In order to pay your bill, call ", jsx("a", __assign({ href: "tel:8888888888" }, { children: "888-888-8888" }))] })] })))] }))] })));
};
Bill.Skeleton = Skeleton;

export { Bill };
